export const CUSTOMER_PAGE_SIZE = 15
export const ORDER_HISTORY_PAGE_SIZE = 10
export const SUPPLIERS_PAGE_SIZE = 10
export const CATALOGUE_PAGE_SIZE = 10
export const SOURCES_PAGE_SIZE = 10
